import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp, FaShieldAlt, FaTruck, FaLeaf } from 'react-icons/fa';
import '../styles/finalCTA.css';

const FinalCTA = () => {
    const navigate = useNavigate();

     const handleShopNow = () => {
        navigate('/all-products');
    };

    const phoneNumber = "917992151205";
const message = "Hi BioSurge! I am interested in your products. Can you help me with the order?";
const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  return (
    <section className="cta-section">
  <div className="cta-grid">
    <div className="cta-feature">
      <FaLeaf /> <span>Ayurvedic Inspired Blend</span>
    </div>
    <div className="cta-feature">
      <FaShieldAlt /> <span>Quality Checked Formula</span>
    </div>
    <div className="cta-feature">
      <FaTruck /> <span>Free Shipping Pan India</span>
    </div>
  </div>

  <div className="cta-content">
    <h2>Ready to Support Your <span className="text-green">Daily Energy?</span></h2>
    <p>Trusted by wellness-focused customers as part of their daily routine.</p>
    
    <div className="cta-buttons">
      <button className="btn-shop" onClick={handleShopNow}>Shop Now</button>
      <button 
        className="btn-wa" 
        onClick={() => window.open(whatsappLink, '_blank')}
      >
        <FaWhatsapp /> Order on WhatsApp
      </button>
    </div>
    <p style={{marginTop:"30px"}}>
  Herbal wellness supplement • Not intended to diagnose, treat, cure, or prevent any disease.
</p>
  </div>
</section>
  );
};

export default FinalCTA;